export enum GuidanceCycle {
    THREE_YF = 'THREE_YF',
    OP1 = 'OP1',
    OP2 = 'OP2',
    Q2G = 'Q2G',
    Q3G = 'Q3G',
    Q4G = 'Q4G',
}
